/* LGT · Wishlist — stockage localStorage, toggle sur ♡, compteur header dynamique */
(function(){
  var KEY = 'lgt_wishlist';

  function read(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch(e){ return []; }
  }
  function write(arr){
    try { localStorage.setItem(KEY, JSON.stringify(arr)); }
    catch(e){}
  }
  function has(handle){ return read().indexOf(handle) >= 0; }
  function toggle(handle){
    var arr = read();
    var i = arr.indexOf(handle);
    if(i >= 0) arr.splice(i, 1); else arr.push(handle);
    write(arr);
    return arr.indexOf(handle) >= 0;
  }
  function count(){ return read().length; }

  function updateHeaderCounter(){
    var c = count();
    var holders = document.querySelectorAll('[data-wishlist-count], .lgt-th__lk-c');
    holders.forEach(function(el){
      if(c > 0){
        el.textContent = '('+c+')';
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function syncCards(){
    document.querySelectorAll('[data-product]').forEach(function(card){
      var handle = card.getAttribute('data-product');
      var btn = card.querySelector('.lgt-pcard__wish');
      if(btn && handle){
        if(has(handle)){
          btn.classList.add('is-active');
          btn.innerHTML = '♥';
          btn.setAttribute('aria-label', 'Retirer des favoris');
        } else {
          btn.classList.remove('is-active');
          btn.innerHTML = '♡';
          btn.setAttribute('aria-label', 'Ajouter aux favoris');
        }
      }
    });
    // PDP heart (if present, future)
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var handle = btn.getAttribute('data-wishlist-toggle');
      if(handle){
        btn.classList.toggle('is-active', has(handle));
      }
    });
  }

  function init(){
    updateHeaderCounter();
    syncCards();

    // Delegation : click sur ♡ (carte produit) ou data-wishlist-toggle (PDP)
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.lgt-pcard__wish');
      if(btn){
        e.preventDefault();
        var card = btn.closest('[data-product]');
        var handle = card && card.getAttribute('data-product');
        if(handle){
          var now = toggle(handle);
          btn.classList.toggle('is-active', now);
          btn.innerHTML = now ? '♥' : '♡';
          btn.setAttribute('aria-label', now ? 'Retirer des favoris' : 'Ajouter aux favoris');
          updateHeaderCounter();
          // Animate
          btn.classList.add('lgt-pcard__wish--pulse');
          setTimeout(function(){ btn.classList.remove('lgt-pcard__wish--pulse'); }, 350);
        }
        return;
      }
      var toggleBtn = e.target.closest('[data-wishlist-toggle]');
      if(toggleBtn){
        e.preventDefault();
        var h = toggleBtn.getAttribute('data-wishlist-toggle');
        if(h){
          var now2 = toggle(h);
          toggleBtn.classList.toggle('is-active', now2);
          updateHeaderCounter();
        }
      }
    });

    // Re-sync après AJAX (pagination, filtres, etc.)
    var mo = new MutationObserver(function(){ syncCards(); });
    document.querySelectorAll('.lgt-cprod__grid').forEach(function(grid){
      mo.observe(grid, { childList:true });
    });

    // Expose API publique
    window.LGTWishlist = {
      get: read,
      has: has,
      add: function(h){ if(!has(h)){ var a=read(); a.push(h); write(a); updateHeaderCounter(); syncCards(); } },
      remove: function(h){ var a=read(); var i=a.indexOf(h); if(i>=0){ a.splice(i,1); write(a); updateHeaderCounter(); syncCards(); } },
      clear: function(){ write([]); updateHeaderCounter(); syncCards(); },
      count: count
    };
    document.dispatchEvent(new CustomEvent('lgt:wishlist:ready'));
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
